import * as url from 'url';
import { merge } from 'lodash';
import { CHILDUPP_ID } from 'shared/childupp-properties';

const URL_CHILDUPP_API = process.env['URL_API_CHILDUPP'];

/**
 * Given an url realtive to the childupp api base url returns the
 * full endpoint url.
 *
 * @param  {string} _url
 * @return {string}
 */
function resolveApiUrl(_url) {
    if (_url.charAt(0) === '/')
        _url = _url.substr(1);
    return url.resolve(URL_CHILDUPP_API, _url);
}

/**
 * Performs a fetch request against the childupp rest API. The request
 * will automatically get the Childupp header for allowing the API
 * to identify which childupp this request is related with.
 *
 * @param  {Request} request
 * @return {Promise<any>}
 *
 * @see shared/childupp-properties
 * @see https://developer.mozilla.org/es/docs/Web/API/Request/Request
 */
export async function fetch(request) {
    const childuppId = await CHILDUPP_ID;
    const url = resolveApiUrl(request.url);
    const req = merge({
        method: request.method || 'GET',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Childupp': childuppId,
            // 'X-Childupp': childuppId,
        },
        body: request.body ? JSON.stringify(request.body) : undefined,
    });

    const res = await window.fetch(url, req);
    if (res.status < 200 || res.status > 299) {
        // Response was unsuccessful
        throw new Error(`API request error: ${res.status}(${res.statusText})`);
    }


    const contentType = res.headers.get("content-type");
    if (/application\/json/.test(contentType)) {
        return res.json();
    } else {
        return res.text();
    }
}

/**
 * Retrieves the config of the currently running childupp.
 * @return {Promise<object>}
 */
export function getConfig() {
    return fetch({
        method: 'POST',
        url: '/v2/app/config',
        body: {
            device: 'phone',
        }
    })
}

/**
 * Retrieves the contents of the custom scripts file to be loaded with the
 * currently running childupp
 * @return {Promise.<string>}
 */
export function getCustomJs() {
    return CHILDUPP_ID
    .then((childuppId) => {
        return fetch({
            method: 'GET',
            url: `/app/scripts/${childuppId}`
        })
    })
}

/**
 * Retrieves the contents of the custom styles file to be loaded with the
 * currently running childupp
 * @return {Promise.<string>}
 */
export function getCustomCss() {
    return CHILDUPP_ID
    .then((childuppId) => {
        return fetch({
            method: 'GET',
            url: `/app/styles/${childuppId}`
        })
    })
}



// WEBPACK FOOTER //
// ./src/shared/childupp-api/index.js